import { render, staticRenderFns } from "./remainTicketNum.vue?vue&type=template&id=11bd3842"
import script from "./remainTicketNum.vue?vue&type=script&lang=js"
export * from "./remainTicketNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports